module.exports = __webpack_public_path__ + "static/media/profissional-icon.95dbcca2.svg";